// path: src/utils/postLoginDestination.ts
import { User } from '../@types';
import { getIpaHomePath, SDD_HOME_PATH } from './ipaAccess';

export const PANEL_HOME_PATH = '/isa/painel-geral';
export const ANALYSIS_PANEL_PATH_PREFIX = '/analise/';
export const CHART_PANEL_PATH_PREFIX = '/acompanhamento/';
export const PANEL_FREE_HOME_PATH = '/isa/painel-geral-free';
export const PRICE_HISTORY_HOME_PATH = '/isa/historico-preco';
export const IRA_HOME_PATH = '/ira';

const FREE_PANEL_PACKAGE = 'FREE';

export type PostLoginDestination = { type: 'path'; path: string } | { type: 'panels' } | { type: 'none' };

const toPath = (path: string): PostLoginDestination => ({ type: 'path', path });

const hasOwnService = (user: User | null | undefined, serviceName: string) => !!user?.servicos?.some(service => service?.name === serviceName);

export const getFirstPanelPath = (user?: User | null): string | null => {
  const panels = [...(user?.servicoBi?.analises ?? []), ...(user?.servicoBi?.graficos ?? [])];
  const firstPanel = panels[0] as { codigo: string; nome?: string } | null | undefined;
  if (!firstPanel) return null;
  return `${firstPanel.nome ? ANALYSIS_PANEL_PATH_PREFIX : CHART_PANEL_PATH_PREFIX}${firstPanel.codigo}`;
};

export const getPostLoginDestination = (user?: User | null): PostLoginDestination => {
  const ipaHomePath = getIpaHomePath(user);
  if (ipaHomePath) return toPath(ipaHomePath);

  if (hasOwnService(user, 'SDD')) return toPath(SDD_HOME_PATH);
  if (hasOwnService(user, 'PAN')) {
    return toPath(user?.servicoPanel?.pacotePainel?.name === FREE_PANEL_PACKAGE ? PANEL_FREE_HOME_PATH : PANEL_HOME_PATH);
  }
  if (hasOwnService(user, 'COL')) return toPath(PRICE_HISTORY_HOME_PATH);
  if (hasOwnService(user, 'IRA')) return toPath(IRA_HOME_PATH);
  if (hasOwnService(user, 'BI')) return { type: 'panels' };
  return { type: 'none' };
};
